import { createContext, useContext } from 'react';
import type { UniversalState } from '../utils/createUniversalState';

export const UniversalStateContext = createContext<UniversalState | undefined>(undefined);

export function useUniversalState(): UniversalState {
  const context = useContext(UniversalStateContext);
  return context || { translations: {} };
}
